<template>
  <header class="w-full flex justify-between items-center border-box">
    <button class="block pointer" @click="handleClick()"></button>
    <h1>Payment</h1>
  </header>
</template>
<script setup>
import {closePage} from "@/utils/bridge";

const handleClick = ()=>{
  document.querySelector('#paypal-button').innerHTML = ''
  closePage()
}

</script>

<style scoped>
header{
  width: 100%;
  height: 22px;
  padding: 53px 16px 0;
  margin-bottom: 40px;
}
@media screen and (min-width:431px){
  header{padding: 53px 30px 0;}
}
button{
  width: 22px;
  height: 22px;
  background: url("../assets/images/back.png") no-repeat center;
  background-size: contain;
}
h1{
  font-family: SF Pro Display;
  font-weight: 600;
  font-size: 18px;
  line-height: 21px;
  color: #212529;
}
header:after{
  content: '';
  display: block;
  width: 22px;
  height: 22px;
}
</style>
